import db, { storage, auth } from '../../../firebase/firebase'
import firebase from "firebase/compat/app"
import moment from 'moment'
import showToast from '../../../util/toast'

const Api = {
    deleteDrugRef: (id) => {
        db.collection("drugrefs")
            .doc(id)
            .delete()
    },

    getDrugRef: (success, error) => {
        console.log('getDrugRef')
        db.collection("drugrefs")
            .get()
            .then(querySnapshot => {
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    const data = doc.data()
                    data.id = doc.id
                    models.push(data)
                }
                success(models)
            })
            .catch(e => {
                // console.log('error: '+JSON.stringify(e));
                console.log('Firestore error:', e);
                error('Load failed!')
            });
    },

    deleteCase: (id) => {
        db.collection("cases")
            .doc(id)
            .delete()
    },

    getCases: (success, error) => {
        db.collection("cases")
            .get()
            .then(querySnapshot => {
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    const data = doc.data()
                    data.id = doc.id
                    models.push(data)
                }
                models.sort((a, b) => b.createdAt.toDate() - a.createdAt.toDate())
                success(models)
            })
            .catch(e => {
                error('Load failed!')
            });
    },

    deleteLecture: (id) => {
        db.collection("lectures")
            .doc(id)
            .delete()
    },

    getLectures: (success, error) => {
        db.collection("lectures")
            .get()
            .then(querySnapshot => {
                // const models = querySnapshot.docs.map(doc => doc.data());
                // models.sort((a, b) => b.added_date - a.added_date)
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    const data = doc.data()
                    data.id = doc.id
                    models.push(data)
                }
                // models.sort((a, b) => b.added_date - a.added_date)
                models.sort((a, b) => {
                    const titleA = a.title || "";
                    const titleB = b.title || "";
                    return titleA.localeCompare(titleB, undefined, {
                        numeric: true,
                        sensitivity: "base",
                    });
                });
                success(models)
            })
            .catch(e => {
                error('Load failed!')
            });
    },

    deleteDoctor: (model, success) => {
        // auth delete
        db.collection("deleteUserCache")
            .add({
                id: model.id,
                email: model.email
            })
        // firestore delete
        db.collection("doctors")
            .doc(model.id)
            .delete()
            .then(() => {
                success()
            })
    },

    //deleteUserCache
    deletePatient: (model, success) => {
        // auth delete
        db.collection("deleteUserCache")
            .add({
                id: model.id,
                email: model.email
            })
        // firestore delete
        db.collection("patients")
            .doc(model.id)
            .delete()
            .then(() => {
                success()
            })
    },

    deleteVideo: (id) => {
        db.collection("videos")
            .doc(id)
            .delete()
    },

    getVideos: (success, error) => {
        db.collection("videos")
            .get()
            .then(querySnapshot => {
                // const models = querySnapshot.docs.map(doc => doc.data());
                // models.sort((a, b) => b.added_date - a.added_date)
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    const data = doc.data()
                    data.id = doc.id
                    models.push(data)
                }
                models.sort((a, b) => b.added_date - a.added_date)
                success(models)
            })
            .catch(e => {
                console.log('err', e);
                error('Load failed!')
            });
    },

    deleteArticle: (id) => {
        db.collection("articles")
            .doc(id)
            .delete()
    },

    getArticles: (success, error) => {
        db.collection("articles")
            .get()
            .then(querySnapshot => {
                // const models = querySnapshot.docs.map(doc => doc.data());
                // models.sort((a, b) => b.added_date - a.added_date)
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    const data = doc.data()
                    data.id = doc.id
                    models.push(data)
                }
                models.sort((a, b) => b.added_date - a.added_date)
                success(models)
            })
            .catch(e => {
                error('Load failed!')
            });
    },

    signupDoctor: async (doctor, password, success, error) => {
        console.log('doctor: ' + JSON.stringify(doctor));
        auth.createUserWithEmailAndPassword(doctor.email, password)
            .then(() => {
                console.log('User signup success');
                // create user in firestore
                db.collection('doctors')
                    .add(doctor)
                    .then((doc) => {
                        console.log(doc.id);
                        console.log('User added success');
                        success(doc.id)
                    })
                    .catch(e => {
                        error(e.message)
                        console.log(e.message);
                    });
            })
            .catch(e => {
                error(e.message)
                console.log(e.message);
            });
    },

    login: (email, password, success, error) => {
        db.collection("admin")
            .where("email", "==", email)
            .where("password", "==", password)
            .get()
            .then(querySnapshot => {
                const data = querySnapshot.docs.map(doc => doc.data());
                if (data.length > 0) {
                    let user = data[0];
                    success(user)
                }
                else {
                    error('Could not login')
                }
            })
    },

    updateAdmin: (email, password, success, error) => {
        db.collection('admin')
            .doc('admin')
            .set({
                email: email,
                password: password,
                updated_on: firebase.firestore.FieldValue.serverTimestamp()
            }, { merge: true })
            .then(() => {
                success()
            })
            .catch(e => {
                error('Update failed!')
            });
    },

    getPatients: (success, error) => {
        db.collection("patients")
            .get()
            .then(querySnapshot => {
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    let model = doc.data()
                    model.id = doc.id
                    models.push(model)
                }
                models.sort((a, b) => b.added_date - a.added_date)
                success(models)
            })
            .catch(e => {
                error('Load failed!')
            })
    },

    getDoctors: (success, error) => {
        db.collection("doctors")
            .get()
            .then(querySnapshot => {
                let models = []
                for (let i = 0; i < querySnapshot.docs.length; i++) {
                    const doc = querySnapshot.docs[i];
                    let model = doc.data()
                    model.id = doc.id
                    models.push(model)
                }
                models.sort((a, b) => b.added_date - a.added_date)
                success(models)
            })
            .catch(e => {
                error('Load failed!')
            })
    },

    getServerTimestamp: (success) => {
        var ref = db.collection('timestamp').doc('timestamp')
        ref.set({ timestamp: firebase.firestore.FieldValue.serverTimestamp() });
        ref.onSnapshot(function (snapshot) {
            var timestamp = snapshot.data().timestamp;
            success(timestamp)
        })
    },

    sendPushToAll: (title, msg, onSuccess, onError) => {
        console.log('sendPushToAll');
        let url = 'https://fcm.googleapis.com/fcm/send'
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'key=AAAA42ItaNU:APA91bEcSHEq5j9L2e3Kes26ua4oAwQeSsB2UaaS2DuyTgMkDRlTovmSli9Q7ije1onSzFBo_294qMOwHyaPqmWys7U8ITIouU7KJrZq_faA9Dt4jkXalwxwwzDnigyevRCjJmjeG2fS'
        }
        let params = {
            "to": "/topics/public_notification",
            "notification": {
                "title": title,
                "body": msg
            },
            "data": {
                'type': 'alert'
            }
        }

        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(params)
        })
            .then(response => response.json())
            .then(result => {
                console.log(JSON.stringify(result));
                if (onSuccess && onSuccess != null) {
                    onSuccess()
                }
            })
            .catch(err => {
                console.log(err)
                if (onError && onError != null) {
                    onError()
                }
            });
    },

    updatePatientStatus: (email, status, success, error) => {
        console.log('email: ' + email);
        console.log('status: ' + status);
        db.collection("patients")
            .where("email", "==", email)
            .get()
            .then(querySnapshot => {
                const doc = querySnapshot.docs[0];
                console.log('docID: ' + doc.id);
                db.collection('patients')
                    .doc(doc.id)
                    .set({
                        status: status
                    }, { merge: true })
                    .then(() => {
                        success()
                    })
                    .catch(e => {
                        console.log(e);
                        error('Update failed!')
                    });
            });
    },

    updateStatus: (email, status, success, error) => {
        console.log('email: ' + email);
        console.log('status: ' + status);
        db.collection("doctors")
            .where("email", "==", email)
            .get()
            .then(querySnapshot => {
                const doc = querySnapshot.docs[0];
                console.log('docID: ' + doc.id);
                db.collection('doctors')
                    .doc(doc.id)
                    .set({
                        status: status
                    }, { merge: true })
                    .then(() => {
                        success()
                    })
                    .catch(e => {
                        console.log(e);
                        error('Update failed!')
                    });
            });
    },

    sendVerifiedEmail: (doctor) => {
        console.log('send email: ' + doctor.email);
        // send email
        let mailParams = {
            "accessToken": "J2ECuXpVbXIVT-Yu-P-wC",
            "service_id": "gmail",
            "template_id": "template_dsv6zmg",
            "user_id": "5yIURgbf9PsA9yLIR",
            "template_params": {
                "name": doctor.name,
                "email": doctor.email
            }
        }
        fetch('https://api.emailjs.com/api/v1.0/email/send', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(mailParams)
        })
            .then(response => response.json())
            .then(result => {
                console.log(JSON.stringify(result))
            })
            .catch(err => {
                console.log(err)
            });
    },

    sendContactUsEmail: (obj) => {
        // send email
        let mailParams = {
            "accessToken": "J2ECuXpVbXIVT-Yu-P-wC",
            "service_id": "gmail",
            "template_id": "template_n5tkgn8",
            "user_id": "5yIURgbf9PsA9yLIR",
            "template_params": {
                "name": obj.name,
                "contact": obj.contact,
                "message": obj.message,
            }
        }
        fetch('https://api.emailjs.com/api/v1.0/email/send', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(mailParams)
        })
            .then(response => response.text())
            .then(result => {
                showToast('success', "Thanks for contacting us. Our admin will reply soon.")
            })
            .catch(err => {
                console.log(err)
            });
    },
}

export default Api;
